import { Profile } from '../profile'

export enum IdentityEvent {
    EMAIL_VERIFIED = 'pnIdEmailVerified',
    FORM_VALIDATED= 'pnFormValidated', // fires when DCS form passed valdation
    IDENTITY_CHANGE = 'pnIdChange', // fires on any identity change event (session start/stop etc.)
    IDENTITY_INIT = 'pnIdInit', // fires immediately with locally-stored profile
    SESSION_INIT = 'pnIdSession', // fires when an SSO session is confirmed active/inactive
    IDENTITY_PROFILE_INIT = 'pnIdProfileInit', // profile initialized
    IDENTITY_SERVICE_INIT = 'pdIdServiceInit', // identity service initialized
    IDENTITY_SESSION_PROFILE_INIT = 'pnIdIdentitySessionProfileInit', // profile loaded
    NEW_LOGIN = 'pnNewLogin', // fires when there is a new login
    PROVIDER_ID_ASSIGNED = 'pnProviderIdAssigned', // fires when identity provider assigns an ID for the user
    LOGIN_MODAL_READY = 'pnLoginModalReady',
    MP_READY = 'pnMpReady', // fires when mParticle becomes available
    COMMENT_LOGIN = 'pnCommentLogin', // when someone wants to login from commenting
    COMMENT_LOGOUT = 'pnCommentLogout', // when someone wants to logout from commenting
    IDENTITY_SIGNOUT = 'pnIdSignOut',
    NEW_REGISTRATION = 'pnNewRegistration', // fires when a new user successfully registers
    IDENTITY_LOGIN = 'pnExplicitLogin', // fires on a callback from the SSO on explicit login
    IDENTITY_READY = 'pnIdReady', // fires when the profile is fully loaded (with adlite)
    IDENTITY_PROFILE_UPDATED = 'pnIdProfileUpdated', // fires when the profile is fully loaded with adlite after signin
    MP_LISTENS = 'mParictle_listeners_ready', // fires when mParticle listeners are initialized
    MP_LOGIN_FINISHED = 'mParticle_login_finished', // user completed registration/login and analytics is ready
    SAVE_RECOMMENDATION_CATEGORIES = 'saveRecommendationCategories', // fires when saves recommendation categories
    RECOMMENDATION_CATEGORIES_SAVED_SUCCESS = 'recommendationCategoriesSavedSuccess', // recommendations saved
    RECOMMENDATION_CATEGORIES_SAVED_ERROR = 'recommendationCategoriesSavedError', // recommendations not saved
    OPEN_RECOMMENDATION_MODAL = 'openRecommendationModal', // Open recommendation Modal
    MICROSOFT_LOGIN_CALLBACK = 'microsoftLoginCallback', // fires when microsoft login callback is called
    SET_PERSON_ID= 'fcPersonId', // fires when we get a valid fullContact person Id,
    ENVELOP_MODULE_READY = 'envelopeModuleReady', // fires when liveRamp is ready
    RESEND_VERIFICATION_EMAIL = 'resend-verification-email',
    INTENTIQ_READY = 'intentIqReady', // fires when intentIq is ready
}

export interface IIdentityEvent<T = Profile> extends CustomEvent<T> {
    detail: T
}
